import { render, staticRenderFns } from "./transporterMdToD.vue?vue&type=template&id=16f2a4fa&scoped=true&"
import script from "./transporterMdToD.vue?vue&type=script&lang=js&"
export * from "./transporterMdToD.vue?vue&type=script&lang=js&"
import style0 from "./transporterMdToD.vue?vue&type=style&index=0&id=16f2a4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2a4fa",
  null
  
)

export default component.exports